import { Loader, Rectangle, Texture } from 'pixi.js';

class TextureFactory {
  public static readonly instance: TextureFactory = new TextureFactory();
  public textures: Record<string, Array<Texture>> = {};

  public has(key: string): boolean {
    return !!this.textures[key];
  }

  public getTextures(key: string, width: number, height: number): Array<Texture> {
    if (!this.has(key)) {
      const baseTexture = Texture.from(Loader.shared.resources[key].data).baseTexture;
      const textureColumn = baseTexture.width / width;
      const textureRows = baseTexture.height / height;

      this.textures[key] = new Array(textureColumn * textureRows).fill(true).map((_v, i) => {
        const [x, y] = [i % textureColumn, Math.floor(i / textureColumn)];
        const texture: Texture = new Texture(baseTexture, new Rectangle(x * width, y * height, width, height));

        texture.defaultAnchor.set(0, 0);

        return texture;
      });
    }

    return this.textures[key];
  }

  public load(textureInfo: {
    name: string;
    texture: string;
    width: number;
    height: number;
    padding: number;
    frames: Array<{ x: number; y: number; w: number; h: number; anchor: { x: number; y: number } }>;
  }): Array<Texture> {
    if (!this.has(textureInfo.name)) {
      const baseTexture = Texture.from(Loader.shared.resources[textureInfo.texture].data).baseTexture;

      this.textures[textureInfo.name] = textureInfo.frames.map((frame) => {
        const texture: Texture = new Texture(baseTexture, new Rectangle(frame.x, frame.y, frame.w, frame.h));

        texture.defaultAnchor.set(frame.anchor.x, frame.anchor.y);

        return texture;
      });
    }

    return this.textures[textureInfo.name];
  }

  public getSingleTexture(texture: string) {
    if (!this.has(texture)) {
      this.textures[texture] = [Texture.from(Loader.shared.resources[texture].data)];
    }

    return this.textures[texture][0];
  }
}

export default TextureFactory;
